<template>
  <div>
    <b-card style="position: relative">
      <div v-if="loading" class="loading_page">
        <orbit-spinner
          :animation-duration="1000"
          :size="100"
          :color="'#0e96b1'"
        />
      </div>

      <b-form
        @submit.prevent="updateDevice"
        class="repeater-form"
        style="overflow: visible"
      >
        <b-row>
          <b-col>
            <b-tabs
              vertical
              content-class="col-12 col-md-9 mt-1 mt-md-0"
              pills
              nav-wrapper-class="col-md-3 col-12 border rounded p-1"
              nav-class="nav-left"
            >
              <b-tab :title="$t('basic Information')" active>
                <info-tab></info-tab>
                <b-col cols="12">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    type="submit"
                    variant="primary"
                    class="mr-1"
                  >
                    {{ $t("Save") }}
                  </b-button>
                </b-col>
              </b-tab>


              <b-tab v-if="$store.state.auth.userData.roles.includes('Super Admin')"
                     :title="$t('camera attributes')" lazy>
                <camera-setup-tab></camera-setup-tab>
              </b-tab>


              <b-tab :title="$t('attributes')" lazy>
                <device-attribute-tab></device-attribute-tab>
                <b-col cols="12">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    type="submit"
                    variant="primary"
                    class="mr-1"
                  >
                    {{ $t("Save") }}
                  </b-button>
                </b-col>
              </b-tab>

              <b-tab :title="$t('scale sensor settings')" lazy>
                <sensors-tab></sensors-tab>
                <b-col cols="12">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    type="submit"
                    variant="primary"
                    class="mr-1"
                  >
                    {{ $t("Save") }}
                  </b-button>
                </b-col>
              </b-tab>

              <b-tab
                @click="refreshData()"
                v-if="
                  $store.state.auth.userData.roles.includes(roles.SUPER_ADMIN)
                "
                :title="$t('Wasl Information')"
                lazy
              >
                <wasl-tab :device-data="deviceData"></wasl-tab>
                <b-col cols="12"></b-col>
              </b-tab>


              <b-tab
                  :title="$t('tech')"
                  v-if="$store.state.auth.userData.roles.includes(roles.SUPER_ADMIN)"
                  lazy
              >
                <tech-tab :device="deviceData.device_id"></tech-tab>
              </b-tab>


              <b-tab 
              :title="$t('DEVICES_FORM_MASADER_TAB_LABEL')" 
              v-if="$store.state.auth.userData.roles.includes(roles.SUPER_ADMIN)" 
              lazy
              >
                <masader-tab />
              </b-tab>

              <b-tab :title="$t('Link device regions')" lazy>
                <regions-tab
                  :device_id="deviceData.device_id"
                  :user="auth.id"
                ></regions-tab>
              </b-tab>

              <b-tab :title="$t('Link Device Drivers')" lazy>
                <drivers-tab :device-data="deviceData"></drivers-tab>
              </b-tab>

              <b-tab :title="$t('DEVICES_MAINTENANCES_TAB_LABEL')" lazy>
                <maintenances-tab />
              </b-tab>

              <b-tab
                :title="$t('Link Device Attributes')"
                lazy
              >
                <attributes-tab :device-data="deviceData"></attributes-tab>
              </b-tab>

              <b-tab 
                :title="$t('SIM')"
                v-if="$store.state.auth.userData.roles.includes(roles.SUPER_ADMIN)"
              
                >
              <sim-tab></sim-tab>
            </b-tab>
            </b-tabs>
          </b-col>

          <!-- reset and submit -->
          <!-- <b-col cols="12">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1">
              {{ $t('Save') }}
            </b-button>
          </b-col> -->
        </b-row>
      </b-form>
    </b-card>
  </div>
</template>
<script>
import { OrbitSpinner } from "epic-spinners";
import {
  BButton,
  BCard,
  BCol,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BRow,
  BAlert,
  BTab,
  BTabs,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";

import router from "@/router";
import DeviceAttributeTab from "@/views/modules/device/tabs/DeviceAttributeTab";
import SensorsTab from "@/views/modules/device/tabs/SensorsTab";
import WaslTab from "@/views/modules/device/tabs/WaslTab";
import MasaderTab from "@/views/modules/device/tabs/MasaderTab";

import RegionsTab from "@/views/modules/device/tabs/RegionsTab";
import DriversTab from "@/views/modules/device/tabs/DriversTab";
import AttributesTab from "@/views/modules/device/tabs/AttributesTab";
import MaintenancesTab from "@/views/modules/device/tabs/MaintenancesTab";
import SimTab from "../tabs/SimTab.vue";
import TechTab from '@/views/modules/device/tabs/TechTab.vue'

import InfoTab from "@/views/modules/device/tabs/InfoTab";
import store from "@/store";
import { computed, onUnmounted } from "@vue/composition-api";
import { DeviceStore } from "@/app/devices/state";
import roles from "@/const/roles";
import CameraSetupTab from '@/views/modules/device/tabs/CameraSetupTab.vue'


export default {
  name: "EditDevice",
  components: {
    CameraSetupTab,
    TechTab,
    InfoTab,
    BRow,
    BCard,
    BCol,
    BAlert,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BInputGroup,
    BInputGroupPrepend,
    BForm,

    DeviceAttributeTab,
    SensorsTab,
    WaslTab,
    MasaderTab,
    RegionsTab,
    DriversTab,
    AttributesTab,
    MaintenancesTab,
    SimTab,

    BButton,
    BTabs,
    BTab,
    vSelect,
    OrbitSpinner,
  },
  directives: {
    Ripple,
  },

  setup(props, { root }) {
    const DEVICE_STORE = "device";

    if (!store.hasModule(DEVICE_STORE))
      store.registerModule(DEVICE_STORE, DeviceStore);

    onUnmounted(() => {
      store.commit("device/INIT_STATE");
      if (store.hasModule(DEVICE_STORE)) store.unregisterModule(DEVICE_STORE);
    });

    const auth = store.state.auth.userData;

    const refreshData = () => {
      store.dispatch("device/fetchDeviceData", router.currentRoute.params.id);
    };
    store.dispatch("device/fetchDeviceData", router.currentRoute.params.id);

    store.dispatch("device/fetchLists", auth.id);

    const loading = computed(() => store.state.device.loading);
    const deviceData = computed(() => store.state.device.data);

    const updateDevice = () => {
      store.dispatch("device/saveData").then((res) => {
        root.$bvToast.toast(root.$i18n.t("device updated successfully"), {
          title: `Success`,
          variant: "success",
        });
      });
    };

    return {
      roles,
      loading,
      deviceData,
      updateDevice,
      auth,
      refreshData,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
